<ng-container *transloco="let t">
  <div class="text">
    <p class="chapter">{{ data.chapter }}</p>
    <p class="question">{{ data.question }}</p>
  </div>
  <div class="button" (click)="buttonClick()">
    <p>{{ t('POPUPS.INFORMATION.CLOSE') }}</p>
  </div>
</ng-container>
